(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-card-media-slider"] && !Shopify.designMode) return;
  try {
    const scheduledProductCardMediaTracks = new WeakSet();

  const hydrateProductCardMediaTrack = (track) => {
    const template = track.querySelector('[data-product-card-media-slider-deferred]');

    if (template) template.replaceWith(template.content.cloneNode(true));
  };

  const updateProductCardMediaProgress = (track) => {
    const maxScroll = track.scrollWidth - track.clientWidth;
    const progress = maxScroll > 0 ? track.scrollLeft / maxScroll : 0;
    const offset = progress * Math.max(0, track.children.length - 1) * 100;

    track
      .closest('[data-product-card-media-slider]')
      .querySelector('.product-card-media-slider__progress-indicator')
      .style.transform = 'translate3d(' + offset + '%, 0, 0)';
  };

  const queueProductCardMediaProgress = (track) => {
    if (scheduledProductCardMediaTracks.has(track)) return;

    scheduledProductCardMediaTracks.add(track);
    requestAnimationFrame(() => {
      updateProductCardMediaProgress(track);
      scheduledProductCardMediaTracks.delete(track);
    });
  };

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-product-card-media-slider-button]');

    if (!button) return;

    const track = button
      .closest('[data-product-card-media-slider]')
      .querySelector('[data-product-card-media-slider-track]');
    const direction = Number(button.dataset.productCardMediaSliderButton);

    hydrateProductCardMediaTrack(track);
    track.scrollBy({ left: track.clientWidth * direction, behavior: 'smooth' });
  });

  document.addEventListener(
    'pointerdown',
    (event) => {
      const track = event.target.closest?.('[data-product-card-media-slider-track]');

      if (track) hydrateProductCardMediaTrack(track);
    },
    { passive: true }
  );

  document.addEventListener('focusin', (event) => {
    const track = event.target.closest?.('[data-product-card-media-slider-track]');

    if (track) hydrateProductCardMediaTrack(track);
  });

  document.addEventListener(
    'scroll',
    (event) => {
      if (event.target.matches?.('[data-product-card-media-slider-track]')) {
        queueProductCardMediaProgress(event.target);
      }
    },
    { capture: true, passive: true }
  );
  } catch(e) { console.error(e); }
})();

})();
